export default __webpack_public_path__ + "static/media/hand_with_phone.eb9cbe10.png";